"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var axiosMethods = [
    'post',
    'put',
    'patch',
    'delete',
    'get',
    'head',
    'options',
    'request',
];
var axiosBetterStacktrace = function (axiosInstance) {
    // do nothing if input does not look like an axios instance
    if (!axiosInstance || !axiosMethods.some(function (method) { return axiosInstance.hasOwnProperty(method); })) {
        return;
    }
    // avoid potential memory leaks if axios instance already patched
    if (axiosInstance.__axiosBetterStacktracePatched) {
        return;
    }
    // ensure original handlers can be restored after patching
    var originalHandlersByMethod = axiosMethods.reduce(function (acc, method) {
        if (method in axiosInstance) {
            acc[method] = axiosInstance[method];
        }
        return acc;
    }, {});
    // extend axios original handlers with a catch block which augments original error with a better stack trace
    axiosMethods.forEach(function (method) {
        if (method in axiosInstance) {
            var methodHandler_1 = axiosInstance[method];
            axiosInstance[method] = function axiosBetterStacktraceMethodProxy() {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                // obtain handler's stack trace at the topmost level possible
                // to provide more details than the original error
                var topmostStack = new Error('Axios Better Stacktrace').stack;
                var handlerResult = methodHandler_1.apply(void 0, args);
                return handlerResult.catch(function (maybeError) {
                    if (maybeError instanceof Error) {
                        var error = maybeError;
                        error.originalStack = maybeError.stack;
                        error.stack = error.stack + "\n" + topmostStack;
                        throw error;
                    }
                    return maybeError;
                });
            };
            if (!axiosInstance.__axiosBetterStacktracePatched) {
                axiosInstance.__axiosBetterStacktracePatched = true;
            }
        }
    });
    // ensure consumer of the plugin can restore original handlers
    var restoreOriginalHandlers = function () {
        Object.keys(originalHandlersByMethod).forEach(function (method) {
            axiosInstance[method] = originalHandlersByMethod[method];
        });
    };
    return restoreOriginalHandlers;
};
exports.default = axiosBetterStacktrace;
//# sourceMappingURL=axiosBetterStacktrace.js.map